import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const apiUrlAddresses = `${process.env.REACT_APP_API_URL}/addres`;
const apiUrlEmpresas = `${process.env.REACT_APP_API_URL}/empresas`;

const CreateAddres = () => {
    const [formData, setFormData] = useState({
        nombre_sede: '',
        direccion: '',
        localidad: '',
        id_empresa: ''
    });
    const [empresas, setEmpresas] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        loadEmpresas();
    }, []);

    const loadEmpresas = async () => {
        try {
            const res = await axios.get(apiUrlEmpresas);
            setEmpresas(res.data || []);
        } catch (error) {
            console.error('Error al cargar empresas:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const store = async (e) => {
        e.preventDefault();

        if (!formData.nombre_sede || formData.nombre_sede.trim() === '') {
            alert('⚠️ El nombre de la sede es obligatorio');
            return;
        }

        if (!formData.id_empresa) {
            alert('⚠️ Debe seleccionar una empresa');
            return;
        }

        setIsSubmitting(true);
        try {
            await axios.post(apiUrlAddresses, formData);
            alert('✅ Sede creada exitosamente');
            navigate('/admin/AbmDirecciones');
        } catch (error) {
            console.error('Error al crear sede:', error);
            alert('❌ Error al crear la sede: ' + (error.response?.data?.error || error.message));
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        navigate('/admin/AbmDirecciones');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-100 py-8 px-4">
            <div className="max-w-4xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-t-2xl shadow-xl p-6 border-b-4 border-blue-500">
                    <div className="flex items-center gap-4">
                        <div className="bg-gradient-to-br from-blue-500 to-cyan-600 p-4 rounded-xl shadow-lg">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-gray-800">Nueva Sede</h1>
                            <p className="text-gray-600 mt-1">Registra una nueva ubicación en el sistema</p>
                        </div>
                    </div>
                </div>

                {/* Form */}
                <form onSubmit={store} className="bg-white rounded-b-2xl shadow-xl p-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Empresa */}
                        <div className="md:col-span-2">
                            <label htmlFor="id_empresa" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-purple-600">🏢</span>
                                Empresa
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                id="id_empresa"
                                name="id_empresa"
                                value={formData.id_empresa}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none text-gray-800"
                            >
                                <option value="">Seleccione una empresa</option>
                                {empresas.map(emp => (
                                    <option key={emp.id_empresa} value={emp.id_empresa}>
                                        {emp.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Nombre Sede */}
                        <div className="md:col-span-2">
                            <label htmlFor="nombre_sede" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-blue-600">📍</span>
                                Nombre de la Sede
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                id="nombre_sede"
                                name="nombre_sede"
                                value={formData.nombre_sede}
                                onChange={handleChange}
                                placeholder="Ej: Sede Central, Sucursal Norte"
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>

                        {/* Dirección */}
                        <div className="md:col-span-2">
                            <label htmlFor="direccion" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-green-600">🏠</span>
                                Dirección
                            </label>
                            <input
                                type="text"
                                id="direccion"
                                name="direccion"
                                value={formData.direccion}
                                onChange={handleChange}
                                placeholder="Calle, número, piso, depto"
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>

                        {/* Localidad */}
                        <div className="md:col-span-2">
                            <label htmlFor="localidad" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-cyan-600">🌆</span>
                                Localidad
                            </label>
                            <input
                                type="text"
                                id="localidad"
                                name="localidad"
                                value={formData.localidad}
                                onChange={handleChange}
                                placeholder="Ciudad, provincia"
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-cyan-500 focus:ring-2 focus:ring-cyan-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>
                    </div>

                    {/* Botones */}
                    <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t-2 border-gray-200">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="flex-1 bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-blue-700 hover:to-cyan-700 transform hover:scale-[1.02] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                        >
                            {isSubmitting ? (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                    </svg>
                                    Guardando...
                                </span>
                            ) : (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    Crear Sede
                                </span>
                            )}
                        </button>

                        <button
                            type="button"
                            onClick={handleCancel}
                            disabled={isSubmitting}
                            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-6 rounded-lg shadow-md transform hover:scale-[1.02] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <span className="flex items-center justify-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                Cancelar
                            </span>
                        </button>
                    </div>
                </form>

                {/* Info adicional */}
                <div className="mt-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg shadow-md">
                    <div className="flex items-start gap-3">
                        <svg className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        <div>
                            <p className="text-sm font-semibold text-blue-900">Información importante</p>
                            <p className="text-sm text-blue-700 mt-1">
                                La sede estará asociada a la empresa seleccionada. Los sectores y usuarios se vincularán a esta sede.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateAddres;